import {Component, EventEmitter, Input, Output, inject} from '@angular/core';
import {Router} from '@angular/router';
import {SiteDetailsService} from '../../../services/site-details.service';
import {SitesManager} from '../../../common/elf-store/sites/sites.manager';
import {PaginationService} from 'src/app/services/pagination.service';
import {UserPermissions} from 'src/app/common/elf-store/user-permissions/user-permissions.store';
import {ProductStatus, SiteSearchEntryDto} from '../../../../userway/sdk/UserWayApiClient';
import {PermissionGuardDirective} from '../../../common/directives/permission-guard.directive';
import {BtnComponent} from '../../../components/dumb/button/button.component';
import {BlurOnComponentDirective} from '../../../common/directives/blur-on-component.directive';
import {MatIconModule} from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'mc-site-list',
  templateUrl: './site-list.component.html',
  styleUrls: ['./site-list.component.scss'],
  imports: [PermissionGuardDirective, BtnComponent, BlurOnComponentDirective, MatIconModule],
})
export class SiteListComponent {
  private router = inject(Router);
  overviewSiteService = inject(SiteDetailsService);
  private sitesManager = inject(SitesManager);
  private paginationService = inject(PaginationService);

  @Input() sites: SiteSearchEntryDto[];
  @Input() showHead: boolean = false;
  @Output() addNewSite = new EventEmitter<Event>();
  @Output() manageSite = new EventEmitter<Event>();
  @Output() goToAllSites = new EventEmitter<Event>();
  @Output() goToEmbedCode = new EventEmitter<Event>();
  @Output() lastElementBlur = new EventEmitter<FocusEvent>();
  readonly iconStaticUrl: string = 'https://s2.googleusercontent.com/s2/favicons?domain=';
  ProductStatus = ProductStatus;
  get UserPermissions() {
    return UserPermissions;
  }

  openViewSite(event: Event, site: SiteSearchEntryDto): void {
    this.router.navigate(
      [`widget/${this.paginationService.currentTab}/p/${this.paginationService.currentPage}/site-details/overview`],
      {
        queryParams: {site: site.host},
        queryParamsHandling: 'merge',
      },
    );
    this.sitesManager.setCurrentSite(site);
    this.manageSite.emit(event);
  }

  openAccountMismatch(event: Event, site: SiteSearchEntryDto): void {
    event.stopPropagation();
    this.router.navigate(
      [`widget/${this.paginationService.currentTab}/p/${this.paginationService.currentPage}/account-mismatch`],
      {
        queryParams: {site: site.host},
        queryParamsHandling: 'merge',
      },
    );
    this.sitesManager.setCurrentSite(site);
    this.manageSite.emit(event);
  }

  openAccessibilityWidget(event: Event) {
    void this.router.navigate(['widget']);
    this.goToAllSites.emit(event);
  }

  handleSiteClick(event: Event, site: SiteSearchEntryDto): void {
    if (this.overviewSiteService.hasIdMismatch(site)) {
      this.openAccountMismatch(event, site);
    } else {
      this.openViewSite(event, site);
    }
  }
}
